{
  "tabs": {
    "overview": "Aperçu",
    "transfers": "Virements",
    "portfolio": "Portefeuille",
    "ledger": "Grand livre",
    "trades": "Opérations"
  },
  "state": {
    "FROZEN": "Gelé",
    "ACTIVE": "Actif",
    "INACTIVE": "Inactif",
    "AWAITING_APPROVAL": "Approbation en attente"
  },
  "highlights": {
    "tradingProcess": "Processus de négociation",
    "goalType": "Type de but : {{goalType}}",
    "portfolio": "Portefeuille: {{portfolioType}}",
    "portfolioTheme": "Thème de portefeuille: {{portfolioTheme}}",
    "feeGrid": "Grille tarifaire",
    "billingCycle": "Cycle de facturation",
    "skipIPS": {
      "true": "IPS : Non requis",
      "false": "IPS : Requis"
    },
    "allowDeposit": "Autoriser les dépôts",
    "suitabilityScore": "Score d'adéquation : {{score}}",
    "allowFractionalShares": "Autoriser le fractionnement d'action",
    "liquidated": "Sous-compte liquidé"
  },
  "createdAt": "Créé le {{date}}",
  "subAccountInformation": "Informations sur le sous-compte",
  "linkedGoal": "Objectif lié",
  "account": "Compte",
  "portfolioInformation": "Informations sur le portefeuille",
  "portfolioTheme": "Thème de portefeuille",
  "portfolio": "Portefeuille",
  "Fees": "Frais",
  "feeGrid": "Grille tarifaire",
  "BilingCycle": "Cycle de facturation",
  "frequency": {
    "BI_WEEKLY": "Bihebdomadaire",
    "DAILY": "Quotidien",
    "LAST_DAY_OF_THE_MONTH": "Dernier jour du mois",
    "MONTHLY": "Mensuel",
    "ONE_TIME": "Une fois",
    "SEMI_MONTHLY": "Bimensuel",
    "WEEKLY": "Hebdomadaire",
    "ANNUAL": "Annuel",
    "QUARTERLY": "Trimestriel",
    "SEMESTRAL": "Semestriel"
  },
  "acceptablePortfolio": "Portefeuille acceptable",
  "notAcceptablePortfolio": "Portefeuille non acceptable",
  "notAcceptableFinancialProduct": "Il ne s'agit pas d'un produit financier acceptable",
  "editSubAccount": "Modifier le sous-compte"
}
